import React, { useState, useCallback } from "react";
import { formatDayMonth } from "utils/formatDate";
import NhapHangApi from "service/QuanLyMuaBan/NhapHangApi";
import { pushNotification } from "utils/notifications";
import InDanhSachNhapHang from "../NhapHang/ChucNang/InDanhSachNhapHang";

const MenuChucNang = ({ dataSearch, listUserName, btnThemMoiClick, RoleThemMoi, RoleIn }) => {
    const [ListFull, setListFull] = useState([]);
    const [ShowIn, setShowIn] = useState(false);
    const [IsPrint, setIsPrint] = useState(null);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const LoadDataInDanhSachNhapHang = useCallback((searchData) => {
        const payload = {
            ...searchData,
            DateFrom: searchData.DateFrom
                ? formatDayMonth(searchData.DateFrom)
                : undefined,
            DateTo: searchData.DateTo
                ? formatDayMonth(searchData.DateTo)
                : undefined,
            pageIndex: -1,
            pageSize: 0,
        };
        console.log("Payload:", payload);
        return NhapHangApi.getData(payload)
            .then((res) => {
                if (res.status === 200) {
                    console.log("Data response full: ", res.data);
                    return res.data || { List: [] };
                } else {
                    console.error("Lỗi khi load dữ liệu in danh sách nhập hàng: ", res.message);
                    pushNotification("In danh sách nhập hàng thất bại!!", "error", "TOP_CENTER", 2000);
                    return { List: [] };
                }
            })
            .catch((error) => {
                console.error("Lỗi khi gọi Api lấy dữ liệu in danh sách nhập hàng:", error);
                pushNotification("Có lỗi xảy ra khi in danh sách nhập hàng!", "error", "TOP_CENTER", 2000);
                return { List: [] };
            });
    }, []);
    const btnXuatExcelClick = () => {
        if (loadingExcel) return;
        setLoadingExcel(true);

        const payload = {
            Type: dataSearch.Type,
            SearchText: dataSearch.SearchText,
            UserName: dataSearch.UserName,
            TrangThai: dataSearch.TrangThai,
            DateFrom: dataSearch.DateFrom
                ? formatDayMonth(dataSearch.DateFrom)
                : "",
            DateTo: dataSearch.DateTo
                ? formatDayMonth(dataSearch.DateTo)
                : "",
        };
        NhapHangApi.xuatExcel(payload)
            .then(response => {
                if (response.status === 200) {
                    const contentDisposition = response.headers["content-disposition"];
                    let fileName = "DanhSachNhapHang.xlsx";
                    if (contentDisposition) {
                        const match = contentDisposition.match(/filename="?(.+)"?/i);
                        if (match && match[1]) {
                            fileName = match[1].replace(/['"]/g, '');
                            try {
                                fileName = decodeURIComponent(fileName);
                            } catch (e) {
                            }
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    pushNotification("Xuất Excel thành công!", "success", "TOP_CENTER", 2000);
                } else {
                    pushNotification("Xuất Excel thất bại!", "error", "TOP_CENTER", 2000);
                }
            })
            .catch(error => {
                console.error("Lỗi khi xuất Excel:", error);
                pushNotification("Có lỗi xảy ra khi xuất Excel!", "error", "TOP_CENTER", 2000);
            })
            .finally(() => {
                setLoadingExcel(false);
            });
    }

    const btnInDanhSachClick = () => {
        console.log("data search in: ", dataSearch)
        LoadDataInDanhSachNhapHang(dataSearch)
            .then((data) => {
                if (data.List && data.List.length > 0) {
                    console.log("List full in danh sach: ", data.List);
                    setListFull(data.List || []);
                    setIsPrint(true);
                    setShowIn(true);
                } else {
                    pushNotification("Không có dữ liệu in theo điều kiện đang chọn!", "error", "TOP_CENTER", 1000);
                }
            })
            .catch((error) => {
                console.error("Lỗi xử lý sau khi load dữ liệu in:", error);
            });
    };
    const ModelClose = () => {
        setIsPrint(null);
        setShowIn(false);
        setListFull([]);
    }

    return (<>
        <div className="" style={{ display: "flex", justifyContent: "space-between", maxWidth: "100%", margin: "10px" }} >
            {RoleThemMoi && (
                <div className="input-sm-new " style={{ maxWidth: "50px", }}>
                    <button type="button" className="btn btn-border-new" onClick={btnThemMoiClick}>
                        <span>
                            <img
                                src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                                style={{ paddingBottom: "5px", marginRight: '6px' }}
                                alt="Thêm mới"
                            />
                            Thêm mới
                        </span>
                    </button>
                </div>
            )}
            <div className="input-sm-new" style={{ minWidth: "30%", maxWidth: "30%", display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
                {RoleIn && (
                <a type="button" className="con-bgnew color-print1" onClick={btnInDanhSachClick} title="In danh sách">
                    <img src="/app-assets/images/logo-print-v2.png" alt="In phiếu" />
                </a>
                )}
                {RoleIn && (
                <a
                    type="button"
                    className="con-bgnew color-print1"
                    onClick={btnXuatExcelClick}
                    disabled={loadingExcel}
                    style={{
                        cursor: loadingExcel ? 'not-allowed' : 'pointer',
                        opacity: loadingExcel ? 0.5 : 1
                    }}
                    title="Xuất Excel"
                >
                    {loadingExcel ? (
                        <span>Đang xuất...</span>
                    ) : (
                        <img src="/app-assets/images/icon-tai-xuong-v2.png" alt="Xuất Excel" />
                    )}
                </a>
                )}
            </div>
        </div>
        {ShowIn && IsPrint === true &&
            <InDanhSachNhapHang
                show={ShowIn}
                onHide={ModelClose}
                listData={ListFull}
                isPrint={IsPrint}
                listUserName={listUserName}
            />
        }
    </>)
}

export default MenuChucNang;